import { Component, OnInit } from '@angular/core';
import { AuthService } from './feature-module/auth/services/auth.service';
import { NavigateService } from './utility/services/navigate/navigate.service';
import { StorageService } from './utility/services/storage/storage.service';
import { TYPE } from './utility/constants/Constant';
import { LoginType } from './utility/enum/global-enum';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  title = 'claims-payment';
  menus: any;
  IsLogIn = false;
  fullName: string;

  menuFilter = [
    'PPO Pre-Approvals',
    'Group Claim Submission List',
    'Investigation Assign Queue',
    'Investigation Entry Queue',
    'HR Dashboard',
    'HR Claim Status',
    'Claims Report',
    'Banca Online Submission',
    'Group Life Claim Submission',
  ];
  year = new Date().getFullYear();
  isShowNotifications = false;
  isShowSettings = false;
  isEbEmployeeDashboard = false;

  constructor(
    private authService: AuthService,
    private navigateService: NavigateService,
    private storageService: StorageService
  ) {
    this.authService.getAuthenitication().subscribe((res) => {
      this.menus = [];
      this.IsLogIn = res;
      this.fullName = '';
      if (this.IsLogIn) {
        this.fullName = this.storageService.getItem('fullName');
        this.menus = this.storageService.getItem('menus');
      }
    });
  }

  ngOnInit() { }

  showNotifications(){
    this.isShowNotifications = !this.isShowNotifications;
    this.isShowSettings = false;
    return this.isShowNotifications;
  }

  showSettings(){
    this.isShowSettings = !this.isShowSettings;
    this.isShowNotifications = false;
    return this.isShowSettings;
  }

  logOut() {
    if(this.isEbDashboard()) 
      this.authService.signoutEnrolDashboard();
    else 
      this.authService.signout();
  }

  changePassword() {
    this.navigateService.toChangePassword();
  }

  getFilteredMenu = (menuname: string): boolean => {
    if (this.menuFilter.find((x) => x == menuname)) {
      return true;
    }
    return false;
  };

  isEbDashboard(){
    return this.storageService.getItem(TYPE) == LoginType.Enrol;
  }
}
